const AVATAR_COLORS = ['#C9561C', '#1E5F59', '#283463', '#7A3E65', '#5C6B1F', '#8A5A12'] as const;

/** Stable tile colour per organisation, so a business keeps its colour across sessions. */
export function organisationAvatarColor(organisationId: string): string {
  let hash = 0;
  for (let i = 0; i < organisationId.length; i += 1) {
    hash = (hash * 31 + organisationId.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]!;
}
